import { IProjectOption } from "Dashboard/domain/IProjectOption";
import { GetProjectsForDropDownOptions, projectService } from "Dashboard/scenes/Projects/services/project.service";
import { useEffect, useState } from "react";

export function useProjectOptions(getProjectsOptions: GetProjectsForDropDownOptions) {
  const [options, setOptions] = useState<IProjectOption[]>([]);

  useEffect(() => {
    async function getProjects() {
      const projects = await projectService.getProjectsForPayable(getProjectsOptions);
      const op = projects.map((project) => {
        return {
          label: project.name,
          value: project.projectId,
          active: project.active
        };
      });
      setOptions(op);
    }

    try {
      getProjects();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return options;
}

export function useProjectOptionsForReceivables(partnerId?: number) {
  const [options, setOptions] = useState<IProjectOption[]>([]);

  useEffect(() => {
    async function getProjects() {
      const projects = partnerId ? await projectService.getProjectsForReceivable(partnerId) : [];
      const op = projects.map((project) => {
        return {
          label: project.name,
          value: project.projectId,
          active: project.active
        };
      });
      setOptions(op);
    }

    try {
      getProjects();
    } catch (err) {
      console.log(err);
    }
  }, [partnerId]);

  return options;
}
